import React, { useState } from "react";
import { useLanguage } from "../Translations/LenguageContext";
import Spinner from "./Spinner";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
    const navigate = useNavigate()
    const { t } = useLanguage();
    const [loading, setLoading] = useState(false)

    const ReloadPage = () => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
            window.location.reload()
        }, 2000);
    }

    return (
        <div className="error_page fade-in">
            <div className="error_page_inner">
                <p className="error_title">{t.error}</p>
                <p className="error_subtitle">{t.err_page}</p>
                <button className="reload_page_btn" onClick={ReloadPage}>
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (
                        <>{t.reload_page}</>
                    )}
                </button>
                <div className="footer_error_page">
                <p className="sub_message">{t.apologies} <span onClick={() => window.open("/dev-docs/errors", "_blank")}><strong>{t.here_link}</strong></span>.</p>
                <p className="sub_message">{t.problem_persists_mex} <span onClick={() => navigate("/control_panel/support")}><strong>{t.erioon_support}</strong></span></p>
                </div>

            </div>
        </div>
    )
}

export default ErrorPage